import Isotope from 'isotope-layout';
import 'isotope-packery';
import 'isotope-cells-by-row';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
//import CustomAnimation from '../animation/customAnimation';
import Splide from '@splidejs/splide';

//let headerSplide;
let teaserSplide;
//const customAnmation = new CustomAnimation();

class Blog {
  isotopeInstance;

  // Hauptinitialisierung
  init() {
    this.initPage();
    this.initTeaserCaroussel();
    this.initParallax();
    setTimeout(() => {
      this.initGrid(); // InitGrid leicht verzögert aufrufen
    }, 100); // Zeit geben, um DOM vollständig zu laden

  }

  initPage = () => {
    /*
    headerSplide = new Splide('.headerSplide', {
      type: 'loop',
      perPage: 1,
      focus: 'center',
      autoplay: false,
      flickMaxPages: 3,
      updateOnMove: true,
      pagination: true,
      throttle: 300,
    });
    headerSplide.mount();
    */
  };

  initTeaserCaroussel = () => {
    const slideCount = document.querySelectorAll('.splide_teaser .splide__slide').length;

    teaserSplide = new Splide('.splide_teaser', {
      type: 'loop',
      perPage: 3,
      focus: 0,
      autoplay: false,
      flickMaxPages: 3,
      updateOnMove: true,
      pagination: false,
      throttle: 300,
      gap: slideCount === 3 ? '2rem' : 0,
      padding: slideCount === 3 ? 0 : undefined,
      breakpoints: {
        991: {
          perPage: 2,
          focus: false,
          gap: '1rem',
          padding: 0,
        },
        768: {
          perPage: 1,
        },
      },
    });
    teaserSplide.on('move', function () {
      // Zusätzliche Bewegungsevents, falls benötigt
    });
    teaserSplide.mount();
    requestAnimationFrame(() => {
      teaserSplide.refresh();
    });

    if (slideCount === 3) {
      document.querySelector('.blog_teaser_box_holder').classList.add('has-three-slides');
    }

    setTimeout(() => {

    }, 500);
  };

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);
    //customAnmation.animateHeaderImage('.header_background');
  };

  // Grid-Layout und Filterfunktionalität
  initGrid = () => {

    this.generateFilterButtons();

    const container = document.querySelector('.blog_grid'); // Blog-Grid auswählen
    const filterButtons = document.querySelectorAll('.filter_button');

    this.isotopeInstance = new Isotope(container, {
      itemSelector: '.blog_overview_teaser',
      layoutMode: 'packery', // Anordnung im "Kachel"-Stil
      transitionDuration: '0.4s', // Animation smoother machen
    });


    // Filter-Button-Events hinzufügen
    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filterValue = button.dataset.filter;

        // Filter aufrufen, 'all' zeigt alle Elemente an
        this.isotopeInstance.arrange({
          filter: filterValue === 'all' ? '*' : `[data-tags*="${filterValue}"]`,
        });

        // Optional: Aktiven Button hervorheben
        filterButtons.forEach((btn) => btn.classList.remove('active'));
        button.classList.add('active');
      });
    });

    // Event-Listener für Layout-Änderungen
    // Event-Listener für Layout-Änderungen
    this.isotopeInstance.on('layoutComplete', () => {
      // ScrollTrigger mit Verzögerung aktualisieren für smoother refresh
      requestAnimationFrame(() => {
        ScrollTrigger.refresh(true);
      });
    });
  };



  generateFilterButtons = () => {
    // Container für die Filter-Buttons auswählen
    const filterContainer = document.querySelector('.filter_buttons');
    if (!filterContainer) return;

    const tags = new Set(); // Set zum Speichern einzigartiger Tags
    const teasers = document.querySelectorAll('.blog_overview_teaser');

    teasers.forEach(teaser => {
      // Alle Tags im jeweiligen Teaser finden
      const tagElements = teaser.querySelectorAll('.blog_overview_teaser_tag');
      const dataTags = Array.from(tagElements).map(tag => tag.textContent.trim().toLowerCase()); // Alle Tags sammeln
      teaser.dataset.tags = dataTags.join(' '); // Dynamisch `data-tags` setzen

      // Tags zum globalen Set hinzufügen
      dataTags.forEach(tag => tags.add(tag)); // Einzigartige Tags sichern
    });

    // Zuerst den "Alle"-Button hinzufügen
    filterContainer.innerHTML = `
    <button class="button filter_button active" data-filter="all">All</button>
  `;

    // Dynamisch Buttons für jeden Tag erstellen
    tags.forEach(tag => {
      const button = document.createElement('button');
      button.className = 'button filter_button';
      button.dataset.filter = tag; // Tag als Filter-Attribut
      button.textContent = tag.charAt(0).toUpperCase() + tag.slice(1); // Tag-Label mit Großbuchstaben
      filterContainer.appendChild(button);
    });
  };



  addFilterEventListeners = () => {
    const filterButtons = document.querySelectorAll('.filter_button');
    const container = document.querySelector('.blog_grid');

    // Sicherstellen, dass der Isotope-Container initialisiert ist
    this.isotopeInstance = new Isotope(container, {
      itemSelector: '.blog_overview_teaser',
      layoutMode: 'packery',
    });

    // Event-Listener für die Buttons hinzufügen
    filterButtons.forEach(button => {
      button.addEventListener('click', () => {
        const filterValue = button.dataset.filter;

        // Filter anwenden
        this.isotopeInstance.arrange({
          filter: filterValue === 'all'
            ? '*'
            : `.blog_overview_teaser:has(.blog_overview_teaser_tag:contains("${filterValue}"))`,
        });

        // Aktiven Button visuell hervorheben
        filterButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
      });
    });
  };



}

export default Blog;
